import React from "react";

const ResultAlert = (props) => {
  return (
    <div>
      {props.type === "not-pass" ? (
        <p className="error">
          Вы не сдали! &nbsp;
          <span role="img" aria-label="sad">
            &#128549;
          </span>
        </p>
      ) : (
        <p className="success">
          Вы сдали! &nbsp;
          <span role="img" aria-label="success">
            &#128077;&#127995;
          </span>
        </p>
      )}
    </div>
  );
};

export default ResultAlert;
